import Slider from './slider/slider';
import Tooltip from 'components/common/tooltip/tooltip';
import QuestionIcon from 'components/icons/QuestionIcon';
import OPNIcon from 'components/icons/OPNIcon';
import { useDelegate } from 'contexts/delegate.context';

import {
  StyledSection,
  StyledHeadingModify,
  StyledList,
  StyledItemModify,
  StyledGridContainer,
  StyledItemText,
  StyledText,
  StyledPanel,
  StyledPanelWrapper,
  StyledPanelSign,
  StyledPanelValue
} from '../single-page.style';

const RightSection = () => {
  const { timeLeft, myProvided, totalProvided } = useDelegate();

  return (
    <StyledSection>
      <StyledHeadingModify>
        <span>Current Status:</span>
        Pool Open
      </StyledHeadingModify>
      <Slider />
      <StyledGridContainer>
        <StyledList>
          <StyledItemModify>
            <StyledItemText>
              Time Left
              <Tooltip
                isMultiline
                type="info"
                message="Indicates estimated time left of <br /> current stage"
              >
                <QuestionIcon />
              </Tooltip>
            </StyledItemText>
            <StyledText>{timeLeft}</StyledText>
          </StyledItemModify>
          <StyledItemModify>
            <StyledItemText>Space Left</StyledItemText>
            <StyledText>{totalProvided}</StyledText>
          </StyledItemModify>
          <StyledItemModify>
            <StyledItemText>Total OPN Provided</StyledItemText>
            <StyledText>{totalProvided}</StyledText>
          </StyledItemModify>
        </StyledList>
        <StyledPanel>
          <h6>My Delegation</h6>
          <StyledPanelWrapper>
            <StyledPanelSign>
              <OPNIcon color="#1c505d" />
              OPN
            </StyledPanelSign>
            <StyledPanelValue>{Number(myProvided).toFixed(2)}</StyledPanelValue>
          </StyledPanelWrapper>
        </StyledPanel>
      </StyledGridContainer>
    </StyledSection>
  );
};

export default RightSection;
